export default __webpack_public_path__ + "static/media/LogoKeraunos.5876926b.png";